export const ProductsPageText = {
  "_1": "Producten",
  "_2": "aircheckr biedt uitgebreide buitenluchtkwaliteitsinformatie voor elke locatie. Onze unieke algoritmen berekenen de luchtkwaliteit tot op het detailniveau dat u nodig hebt: real-time, voorspellingen en statistieken. aircheckr kan eenvoudig worden geïntegreerd in uw toepassingen via onze API en widgets."
};

export const Categories = {
  "_1": {
    "title": "Specificaties",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "Eenvoudig",
        "text": "De complete set aan complexe info vertaald in slechts één waarde, de Europese luchtkwaliteitsindex, maar je kunt ook alle details per polluent krijgen"
      },
      {
        "key": 1,
        "subtitle": "Gedetailleerd",
        "text": "Voor de locatie van de apparaten van je klanten (locatiegebaseerd), maar je kunt ook de geaggregeerde luchtkwaliteitsinfo krijgen, bijvoorbeeld voor jouw stad"
      },
      {
        "key": 2,
        "subtitle": "Gezondheid gebaseerd",
        "text": "Onze luchtkwaliteitsinformatie geeft gepersonaliseerde aanbevelingen en hints"
      },
      {
        "key": 3,
        "subtitle": "Op maat gemaakt",
        "text": "Aangepast aan de details van je toepassing. Kies de specificaties die je precies nodig hebt. We helpen je ook graag verder"
      },
      {
        "key": 4,
        "subtitle": "Eenvoudige integratie",
        "text": "Vloeiende gegevensoverdracht ('machine to machine'). In een handomdraai luchtkwaliteitsdata integreren in een breed scala aan producten/diensten"
      },
      {
        "key": 5,
        "subtitle": "Hoge kwaliteit",
        "text": "Intensief gevalideerd, ook door externe specialisten"
      },
      {
        "key": 6,
        "subtitle": "Snel",
        "text": "Real-time, maar u kunt ook een voorspelling (komende uren/dagen) of statistische gegevens verkrijgen"
      },
      {
        "key": 7,
        "subtitle": "Ondersteuning",
        "text": "We helpen je graag om uw product of demo tot een succes te maken"
      }
    ]
  },
  "_2": {
    "title": "Unieke algoritmen",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "4 belangrijke polluenten",
        "text": "aircheckr berekent de buitenluchtkwaliteit op basis van de meest schadelijke polluenten: NO2, O3, PM10 en PM2.5"
      },
      {
        "key": 1,
        "subtitle": "Slimme modellering",
        "text": "aircheckr ontwikkelde unieke, snelle en on-the-fly modellering en verwerkingstechnieken, om zo de enorme hoeveelheid gegevens te kunnen behandelen en de berekeningen te versnellen"
      },
      {
        "key": 2,
        "subtitle": "Top invoergegevens",
        "text": "Geen goede resultaten zonder goede invoergegevens. We gebruiken de best beschikbare real-time luchtkwalitetismetingen en -modellen, weergegevens, landgebruik (~ bronnen van luchtvervuiling) en crowdsourced metingen als input voor onze modellen"
      },
      {
        "key": 3,
        "subtitle": "Lokaal getint",
        "text": "Elk land / regio is anders. aircheckr past zijn modellen aan met de best beschikbare lokale gegevens"
      },
      {
        "key": 4,
        "subtitle": "Handige API",
        "text": "Onze RESTful API laat u toe om behendig te zijn: de exacte informatie die u nodig heeft op dit moment voor uw toepassing"
      }
    ]
  },
  "_3": {
    "title": "Onze portfolio",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "Detail vanaf stadsniveau",
        "text": "De aircheckr API en widgets bieden voor alle steden / gemeenten, arrondissementen, provincies, regio's en landen in heel wat EU-landen de volgende luchtkwaliteitsgegevens:",
        "text_2": "<strong>Uurlijkse luchtkwaliteitsdata</strong>: real-time, maar ook tot 24 uur terug en voorspellingen voor de komende 24 uur",
        "text_3": "<strong>Dagelijkse luchtkwaliteitsgegevens</strong>: gisteren, vandaag, morgen en overmorgen",
        "text_4": "<strong>Jaarlijkse statistieken</strong>: vanaf 2005 (op dit moment enkel voor België)"
      },
      {
        "key": 1,
        "subtitle": "We werken hard om onze portfolio uit te breiden",
        "text": "Als je specifieke wensen hebt die nu nog niet mogelijk zijn met aircheckr, <a href=\"https://www.aircheckr.com/contact\">neem dan contact met ons op.</a>"
      }
    ]
  },
  "_4": {
    "title": "Implementeer",
    "subcategories": [
      {
        "key": 0,
        "subtitle": "Integreer onze API of kies voor onze widget",
        "text": "Gebruik de API om de aircheckr gegevens die je nodig hebt te bevragen. De aircheckr API zorgt voor een soepele gegevensoverdracht ('machine to machine') en maakt het eenvoudig om luchtkwaliteitsdata te implementeren in je eigen toepassingen. Aarzel niet om <a href=\"https://www.aircheckr.com/contact\">ons te contacteren</a>. We helpen je graag verder.",
        "text_2": "Wil je de bezoekers van je website een aantrekkelijk visualisatie tonen over de huidige luchtkwaliteit? Integreer dan onze widget in je eigen site."
      }
    ]
  }
};

export default ProductsPageText;



// WEBPACK FOOTER //
// ./src/input-text/nl/products_page.js